import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_HISTOGRAMA_INGRESO_POR_USUARIO } from '../../../../config/tables'

function HistogramaIngresoUsuarioView () {
  return (
    <MuiTable id={TABLA_HISTOGRAMA_INGRESO_POR_USUARIO} />
  )
}

export default HistogramaIngresoUsuarioView
